<template>
  <ul
    v-if="isHomeVersionPremium"
    class="type-toggle nav nav-fill nav-pills"
    id="pills-tab"
    role="tablist"
  >
    <v-sheet
      class="mx-auto slider-width"
      max-width="100%"
      width="100%"
      style="background: none"
    >
      <v-slide-group
        show-arrows="desktop"
        mandatory
        class="menu-center align-items-center"
      >
        <template v-for="(menu, index) in sortedMenuList">
          <v-slide-item
            v-if="
              menu !== undefined &&
                menu.type === 'menu_group' &&
                displayMenu(menu) &&
                !disableMenuGroup(menu) &&
                validMenuGroupProducts(menu)
            "
            :key="`menu_group${index}`"
            v-slot="{ active }"
            class="px-2"
            v-touch="{
              left: () => $emit('childSwipe', { direction: 'Left', index: 0 }),
              right: () =>
                $emit('childSwipe', { direction: 'Right', index: 0 }),
              up: () => $emit('childSwipe', { direction: 'Up', index: 0 }),
              down: () => $emit('childSwipe', { direction: 'Down', index: 0 })
            }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="menu.menu_image"
                  :input-value="active"
                  :key="`menu_group_${index}`"
                  :ripple="false"
                  class="mb-2 premium-slider-btn img-button"
                  depressed
                  rounded
                  @click="onMenuGroupTab(menu.id, menu)"
                  :style="{
                    backgroundImage: 'url(' + menu.menu_image + ')'
                  }"
                  v-bind="attrs"
                  v-on="on"
                >
                </v-btn>
                <v-btn
                  v-else
                  :input-value="active"
                  :key="`menu_pre_${index}`"
                  :ripple="false"
                  class="mb-2 premium-slider-btn letter-button"
                  depressed
                  rounded
                  @click="onMenuGroupTab(menu.id, menu)"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ getFirstLetter(menu.name) }}
                </v-btn>
              </template>
              <span>{{ translate("name", menu) }}</span>
            </v-tooltip>
          </v-slide-item>
          <v-slide-item
            v-if="
              menu !== undefined &&
                menu.type === 'menus' &&
                displayMenu(menu) &&
                !disableMenuBySchedule(menu) &&
                validMenuProducts(menu)
            "
            :key="index"
            v-slot="{ active }"
            class="px-2"
            v-touch="{
              left: () => $emit('childSwipe', { direction: 'Left', index: 0 }),
              right: () =>
                $emit('childSwipe', { direction: 'Right', index: 0 }),
              up: () => $emit('childSwipe', { direction: 'Up', index: 0 }),
              down: () => $emit('childSwipe', { direction: 'Down', index: 0 })
            }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="menu.menu_image"
                  :input-value="active"
                  :key="`menu_premium_${index}`"
                  :ripple="false"
                  class="mb-2 premium-slider-btn img-button"
                  depressed
                  rounded
                  @click="onTab(menu.id, menu)"
                  :style="{
                    backgroundImage: 'url(' + menu.menu_image + ')'
                  }"
                  v-bind="attrs"
                  v-on="on"
                >
                </v-btn>
                <v-btn
                  v-else
                  :input-value="active"
                  :key="`menu_pre_${index}`"
                  :ripple="false"
                  class="mb-2 premium-slider-btn letter-button"
                  depressed
                  rounded
                  @click="onTab(menu.id, menu)"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ getFirstLetter(menu.name) }}
                </v-btn>
              </template>
              <span>{{ translate("name", menu) }}</span>
            </v-tooltip>
          </v-slide-item>
          <v-slide-item
            :key="`food${index}`"
            class="px-2"
            v-slot:default="{ active }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.food &&
                !disableAddFood &&
                displayComidas() &&
                validFood
            "
            v-touch="{
              left: () => $emit('childSwipe', { direction: 'Left', index: 0 }),
              right: () =>
                $emit('childSwipe', { direction: 'Right', index: 0 }),
              up: () => $emit('childSwipe', { direction: 'Up', index: 0 }),
              down: () => $emit('childSwipe', { direction: 'Down', index: 0 })
            }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mb-2 premium-slider-btn img-button"
                  depressed
                  v-if="settings && settings.menus && settings.menus.comida"
                  :style="{
                    backgroundImage: 'url(' + settings.menus.comida + ')'
                  }"
                  rounded
                  :ripple="false"
                  :class="'active'"
                  @click="onTab(productTypeIds.food, 'Comida')"
                  v-bind="attrs"
                  v-on="on"
                >
                </v-btn>
                <v-btn
                  v-else
                  class="mb-2 premium-slider-btn letter-button"
                  :input-value="active"
                  depressed
                  rounded
                  :ripple="false"
                  :class="'active'"
                  @click="onTab(productTypeIds.food)"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ getFirstLetter("Comida") }}
                </v-btn>
              </template>
              <span> {{ $t("common.food") }} </span>
            </v-tooltip>
          </v-slide-item>
          <v-slide-item
            :key="`drinks${index}`"
            class="px-2"
            v-slot:default="{ active, toggle }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.drinks &&
                !disableAddDrinks &&
                displayBebidas() &&
                validDrinks
            "
            v-touch="{
              left: () => $emit('childSwipe', { direction: 'Left', index: 0 }),
              right: () =>
                $emit('childSwipe', { direction: 'Right', index: 0 }),
              up: () => $emit('childSwipe', { direction: 'Up', index: 0 }),
              down: () => $emit('childSwipe', { direction: 'Down', index: 0 })
            }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="settings && settings.menus && settings.menus.bebida"
                  :style="{
                    backgroundImage: 'url(' + settings.menus.bebida + ')'
                  }"
                  class="mb-2 premium-slider-btn img-button"
                  depressed
                  rounded
                  :ripple="false"
                  :class="`bebida-btn`"
                  @click="onTab(productTypeIds.drinks, 'Bebida')"
                  v-bind="attrs"
                  v-on="on"
                >
                </v-btn>
                <v-btn
                  v-else
                  class="mb-2 premium-slider-btn letter-button"
                  depressed
                  rounded
                  :input-value="active"
                  :ripple="false"
                  :class="'active'"
                  @click="
                    onTab(productTypeIds.drinks);
                    toggle;
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ getFirstLetter("Bebida") }}
                </v-btn>
              </template>
              <span>{{ $t("common.drinks") }}</span>
            </v-tooltip>
          </v-slide-item>
          <v-slide-item
            :key="`dessert${index}`"
            class="px-2"
            v-slot:default="{ active, toggle }"
            v-if="
              menu !== undefined &&
                menu.type === 'principal' &&
                menu.id === productTypeIds.dessert &&
                !disableAddDessert &&
                displayPostres() &&
                validDessert
            "
            v-touch="{
              left: () => $emit('childSwipe', { direction: 'Left', index: 0 }),
              right: () =>
                $emit('childSwipe', { direction: 'Right', index: 0 }),
              up: () => $emit('childSwipe', { direction: 'Up', index: 0 }),
              down: () => $emit('childSwipe', { direction: 'Down', index: 0 })
            }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="settings && settings.menus && settings.menus.postre"
                  class="mb-2 premium-slider-btn img-button"
                  :style="{
                    backgroundImage: 'url(' + settings.menus.postre + ')'
                  }"
                  depressed
                  rounded
                  :ripple="false"
                  :class="`bebida-btn`"
                  @click="onTab(productTypeIds.dessert, 'Postre')"
                  v-bind="attrs"
                  v-on="on"
                >
                </v-btn>
                <v-btn
                  v-else
                  class="mb-2 premium-slider-btn letter-button"
                  depressed
                  rounded
                  :input-value="active"
                  :ripple="false"
                  :class="'active'"
                  @click="
                    onTab(productTypeIds.dessert);
                    toggle;
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ getFirstLetter("Postre") }}
                </v-btn>
              </template>
              <span>{{ $t("common.dessert") }}</span>
            </v-tooltip>
          </v-slide-item>
        </template>
      </v-slide-group>
    </v-sheet>
  </ul>
</template>

<script>
export default {
  name: "PremiumSlider",
  props: [
    "menus",
    "menuGroup",
    "scheduleByMenu",
    "scheduleByMenuGroup",
    "disableAddFood",
    "disableAddDrinks",
    "disableAddDessert",
    "food",
    "drinks",
    "dessert",
    "sortedMenuList",
    "validFood",
    "validDrinks",
    "validDessert"
  ],
  methods: {
    disableMenuBySchedule(menu) {
      let menuSchedule = this.scheduleByMenu.find(x => x.menuId === menu.id);
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    disableMenuGroup(menu) {
      let menuSchedule = this.scheduleByMenuGroup.find(
        x => x.menuId === menu.id
      );
      return menuSchedule ? this.disableMenu(menuSchedule.schedule) : false;
    },
    onTab(Id, menu) {
      if (Id === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID) {
        this.$emit("onTab", Id, this.$t("common.drinks"));
      }

      if (Id === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID) {
        this.$emit("onTab", Id, this.$t("common.food"));
      }

      if (Id === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID) {
        this.$emit("onTab", Id, this.$t("common.dessert"));
      }
      if (typeof menu === "object") {
        this.$emit("onTab", Id, this.translate("name", menu));
      }
    },
    onMenuGroupTab(menuGroupId, menuGroup) {
      this.$emit(
        "onMenuGroupTab",
        menuGroupId,
        this.translate("name", menuGroup)
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
